import { createLabel, deleteLabel, getLabel, updateLabel } from "api/unity";

const labelConfig = {
  createLabel,
  deleteLabel,
  getLabel,
  updateLabel
};

export default labelConfig;